window.global ||= window;